import CampusDeviceModal from './CampusDeviceModal';

export default CampusDeviceModal;
